import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import Header from "./components/Header";
import Loader from "@componentsShared/Loader/Loader";
import stl from "./Layout.module.css";
import loadable from "@loadable/component";
import useIsFirstInteraction from "@hooks/useIsFirstInteraction";
import useIsWebView from "@hooks/useIsWebview";
import useIsMobile from "@hooks/useIsMobile";
import useIsIOS from "@hooks/useIsIOS";
import { BUILD_VERSION, ENABLE_PING_SECURITY, SHOW_DEBUG_INFO } from "@globalConfig";
import useApi from "@hooks/useApi";
import { api__me } from "@/apis/customer/me";
import useFullLoading from "@hooks/useFullLoading";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import useWebView from "@hooks/useWebview";
import { useTranslation } from "@i18n";
var IS_CLIENT_LOADED = 1500;
var fallback = /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
var DownloadAppBanner = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-DownloadAppBanner-DownloadAppBanner";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-DownloadAppBanner-DownloadAppBanner" */"./components/DownloadAppBanner/DownloadAppBanner");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/DownloadAppBanner/DownloadAppBanner");
    }
    return eval('require.resolve')("./components/DownloadAppBanner/DownloadAppBanner");
  }
}, fallback);
var NewAside = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-NewAside-NewAside";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-NewAside-NewAside" */"./components/NewAside/NewAside");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/NewAside/NewAside");
    }
    return eval('require.resolve')("./components/NewAside/NewAside");
  }
}, fallback);
var MobileFooter = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-MobileFooter-MobileFooter";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-MobileFooter-MobileFooter" */"./components/MobileFooter/MobileFooter");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/MobileFooter/MobileFooter");
    }
    return eval('require.resolve')("./components/MobileFooter/MobileFooter");
  }
}, fallback);
var Footer = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-Footer";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-Footer" */"./components/Footer");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/Footer");
    }
    return eval('require.resolve')("./components/Footer");
  }
}, fallback);
var NavBar = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-NavBar-NavBar";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-NavBar-NavBar" */"./components/NavBar/NavBar");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/NavBar/NavBar");
    }
    return eval('require.resolve')("./components/NavBar/NavBar");
  }
}, fallback);
var ContactUsPopUp = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-ContactUsPopUp-ContactUsPopUp";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-ContactUsPopUp-ContactUsPopUp" */"./components/ContactUsPopUp/ContactUsPopUp");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/ContactUsPopUp/ContactUsPopUp");
    }
    return eval('require.resolve')("./components/ContactUsPopUp/ContactUsPopUp");
  }
}, fallback);
function Layout(props) {
  var webview = useWebView();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var loading = typeof props.loading === 'boolean' ? props.loading : useFullLoading();
  var isWebView = useIsWebView();
  var isIos = useIsIOS();
  var isMobile = useIsMobile();
  var isFirstInteraction = useIsFirstInteraction();
  var isTracking = !!props.tracking;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useState = useState(false),
    isClientLoaded = _useState[0],
    setIsClientLoaded = _useState[1];
  var _useCarCompareContext = useCarCompareContext(),
    hasCarsToCompare = _useCarCompareContext.hasCarsToCompare,
    isCompareBarAllowed = _useCarCompareContext.isCompareBarAllowed;
  var _useApi = useApi([], function () {
      return api__me(isLoggedIn && ENABLE_PING_SECURITY);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    _ = _useApi2[0],
    __ = _useApi2[1],
    ___ = _useApi2[2];

  // Replicate componentDidMount
  useEffect(function () {
    setDocHeight();
    window.addEventListener("resize", setDocHeight);
    window.addEventListener("orientationchange", setDocHeight);
    return function () {
      window.removeEventListener("resize", setDocHeight);
      window.removeEventListener("orientationchange", setDocHeight);
    };
  }, []);
  var setDocHeight = function setDocHeight() {
    document.documentElement.style.setProperty("--vh", "".concat(window.innerHeight / 100, "px"));
  };
  if (__IS_CSR__) {
    var _window$location$sear;
    IS_CLIENT_LOADED = ((_window$location$sear = window.location.search.split('IS_CLIENT_LOADED=')) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear[1]) || IS_CLIENT_LOADED;
  }
  useEffect(function () {
    setTimeout(function () {
      setIsClientLoaded(true);
    }, IS_CLIENT_LOADED);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: "#main-content",
    className: stl.skipLink
  }, "Skip to main content"), /*#__PURE__*/React.createElement("div", {
    className: [props.authenticationMsg ? stl.hasAuthPad : undefined, props.hasNavBar ? stl.hasNavBar : undefined, isWebView ? "webview" : "", __IS_CSR__ && isClientLoaded ? "isLoaded" : "", isTracking ? "isTracking" : "", isIos ? "IOS" : "", "MainContainerLO"].join(" ")
  }, !props.disableLoader && loading && /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement(Header, {
    setUnbxdPage: props.setUnbxdPage,
    showSearchBar: props.showSearchBar,
    hideBannerCssOnly: props.hideBannerCssOnly,
    custommobileHeader: props.custommobileHeader,
    custommobileHeaderFragmentOnly: props.custommobileHeaderFragmentOnly,
    mobileHasBack: props.mobileHasBack,
    homeSearchHeader: props.homeSearchHeader,
    searchSearchHeader: props.searchSearchHeader,
    deal: props.deal,
    loading: loading,
    hideAdvSearchMobile: props.hideAdvSearchMobile,
    headHideLinks: true
    // headHideLinks={props.headHideLinks}
    ,
    headHideLinksMobile: props.headHideLinksMobile === undefined ? true : props.headHideLinksMobile,
    mobileHasTitle: props.mobileHasTitle,
    mobileNoLogo: props.mobileNoLogo,
    mobileNoLogoHasBack: props.mobileNoLogoHasBack,
    notification: props.notification,
    resetSearchFilters: props.resetSearchFilters
    // hideOrangeHeadBtn={props.hideOrangeHeadBtn}
    ,
    hideOrangeHeadBtn: true,
    burgrMenuisCncl: props.burgrMenuisCncl,
    logoNotClickable: props.logoNotClickable,
    hideMenu: props.hideMenu,
    revampedHEading: props.revampedHEading,
    revampedSearch: props.revampedSearch,
    tracking: props.tracking,
    linksForSearch: props.linksForSearch,
    hideSideMenue: props.hideSideMenue,
    hideAppBanner: props.hideAppBanner,
    hideBurgerMenu: props.hideBurgerMenu,
    hideHeaderOnmobile: props.hideHeaderOnmobile,
    straightHeader: props.straightHeader,
    hideHeadOnScroll: props === null || props === void 0 ? void 0 : props.hideHeadOnScroll,
    showUserAvatar: props === null || props === void 0 ? void 0 : props.showUserAvatar,
    showCartIcon: props === null || props === void 0 ? void 0 : props.showCartIcon
  }), !isWebView && isMobile && !props.hideAppBanner && /*#__PURE__*/React.createElement(DownloadAppBanner, {
    hideDownloadBanner: props === null || props === void 0 ? void 0 : props.hideDownloadBanner
  }), /*#__PURE__*/React.createElement("main", {
    id: "main-content",
    className: [props.mainClass ? props.mainClass : undefined].join(" ")
  }, props === null || props === void 0 ? void 0 : props.children), !isMobile && !props.hideFooter && /*#__PURE__*/React.createElement(Footer, {
    hideFooterWithoutAuthMsg: props.hideFooterWithoutAuthMsg,
    authenticationMsg: props.authenticationMsg
  }), isMobile && props.hasMobFooter && /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, /*#__PURE__*/React.createElement(MobileFooter, null)), hasCarsToCompare() && isCompareBarAllowed() ? /*#__PURE__*/React.createElement(React.Fragment, null) : isMobile && props.hasNavBar && /*#__PURE__*/React.createElement(NavBar, _extends({
    customStickyButton: props.customStikeyButton
  }, props))), /*#__PURE__*/React.createElement(NewAside, {
    switchLink: props.switchLink
  }), /*#__PURE__*/React.createElement("div", {
    id: "popUpId"
  }), props.hasContactUs && isFirstInteraction && /*#__PURE__*/React.createElement(ContactUsPopUp, null), SHOW_DEBUG_INFO && BUILD_VERSION && /*#__PURE__*/React.createElement("div", {
    id: "build-version",
    className: "text-xs w-full mt-5 text-lightGray text-center"
  }, /*#__PURE__*/React.createElement("span", null, t("version", {
    ns: "web_aside_menu"
  }), ": ", /*#__PURE__*/React.createElement("strong", null, BUILD_VERSION))));
}
export default Layout;